<template>

    <div class="trax-guide" v-show="loaded">
        <div class="row" v-for="(competency, code) in data" :key="code" v-if="competency.length > 0">

            <div class="col-sm-2 pb-2 pr-0 text-sm-center">
                <span class="badge badge-default" v-if="competency_domains_tags[code]">{{ competency_domains_tags[code] }}</span>
            </div>

            <div class="col-sm-10">
                <ul class="pl-3">
                    <li v-for="item in competency" :key="item.id" class="mb-2" style="font-size:0.8rem; white-space:pre-wrap;">{{ item.name }}</li>                    
                </ul>
            </div>

        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/learning-units/'+data.item.id+'/competencies',
                loaded: false,
                competency_domains_tags: data.competency_domains_tags,
                data: {}
            }
        },

        created: function() {
            this.bus.$on(this.id+'-load-guide', this.getData);
        },

        methods: {

            getData(settings) {
                var that = this;
                that.loaded = false;
                axios.get(this.endpoint, { params: settings })
                .then(function (response) {
                    that.setData(response.data.data);
                    that.loaded = true;
                })
            },

            setData(indicators) {
                this.data = { _: []};     // For indicators none assigned to a competency
                for (var index in indicators) {
                    var indicator = indicators[index];
                    var competency = this.indicatorCompetency(indicator);
                    if (this.data[competency] == undefined) this.data[competency] = [];
                    this.data[competency].push(indicator);
                }
            },

            indicatorCompetency(indicator) {
                if (this.competency_domains_tags[indicator.type]) {
                    return indicator.type;
                } else if (indicator.competencies && indicator.competencies.length > 0) {
                    return indicator.competencies[0];
                } else {
                    return '_';
                }
            }

        }
    }
</script>
